// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ey8w","top":"styles_top__1tmPi","left":"styles_left__30ahT","description":"styles_description__134KM"};